import Observer from 'fontfaceobserver';
export function injectFont(primaryFont, secondaryFonts) {
  // Add `xxxx-ready` styles to set the primary (body) font
  if (primaryFont) {
    // observe body font
    const primaryFontObserver = new Observer(primaryFont);
    primaryFontObserver.load().then(
      () => {
        const fontClass = `primary-font-ready`;
        document && document.documentElement.classList.add(fontClass);
      },
      () => {
        console.log(`Font ${primaryFont} not available`);
      }
    );
  }
  // observe any secondary fonts
  if (secondaryFonts && secondaryFonts.length > 0) {
    const fonts = secondaryFonts.map(font => new Observer(font));
    Promise.all(fonts.map(f => f.load())).then(
      function(e) {
        e.map(fam => {
          const fontClass = 'secondary-font-ready';
          document && document.documentElement.classList.add(fontClass);
          return true;
        });
      },
      () => {
        console.log('Secondary fonts not available');
      }
    );
  }
}
//# sourceMappingURL=injectFont.js.map
